import React, { useState } from "react";

import FormInput from "components/atoms/input/FormInput";
import useLoading from "components/atoms/loading/useLoading";

import { ModalContainer, ModalDescText } from "components/page/modal/styled";
import AbstractModal from "components/page/modal/AbstractModal";

import { genericEnterKeyDown } from "utils/validation";

function ReferenceAddDoiModal(props) {
    const [doi, setDoi] = useState("");
    const { setLoading } = useLoading();

    const handleAddButton = () => {
        setLoading(true, "참고문헌 정보를 확인 중입니다.");
        props.mutation.mutate(
            {
                addFromSource: true,
                body: {
                    source: "doi",
                    source_id: doi,
                },
            },
            {
                onSettled: () => {
                    setLoading(false);
                },
            },
        );
    };

    return (
        <AbstractModal
            modalTitle="DOI로 참고문헌 추가"
            width={480}
            exitModal={props.exitModal}
            footer={{
                leftBtnText: "취소",
                rightBtnText: "추가",
                leftOnClick: props.exitModal,
                rightOnClick: handleAddButton,
                disabled: !doi,
            }}
        >
            <ModalContainer>
                <ModalDescText>참고문헌 추가를 위해 DOI를 입력해주세요.</ModalDescText>
                <FormInput
                    width="100%"
                    margin="24px 0 0 0"
                    label="DOI"
                    bgColor="var(--color-Base1)"
                    borderless
                    requiredMark
                    rightInfoText="DOI"
                    tooltipMessage="DOI(Digital Object Identifier)는 디지털 콘텐츠를 고유하게 식별하는 데 사용되는 표준 정보 식별자입니다."
                    placeholder="EX) 10.1038/nature16961"
                    onChange={(e) => setDoi(e.target.value)}
                    onKeyDown={(e) => {
                        genericEnterKeyDown(e, () => {
                            handleAddButton();
                        });
                    }}
                    value={doi}
                />
            </ModalContainer>
        </AbstractModal>
    );
}

export default ReferenceAddDoiModal;
